import { Injectable } from '@angular/core';
import { HttpMethod } from '../enums/http-handlers';
import { checkNullorUndefined } from '../utilities/functions/checknullorundefined';
import { ApiService } from './api.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AlertInfo } from '../enums/alert-info';
import { AlertService } from './alert.service';
import { LOGIN } from '../enums/urls';
import { Appconfig } from '../enums/app-config';
import Swal from 'sweetalert2';
import { RedirectRoutes } from '../enums/routes';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})

export class SessionService {
  visibility: BehaviorSubject<boolean>;
  showSpinner: BehaviorSubject<boolean>;
  subscription: Subscription = new Subscription();
  remainingMinutes: BehaviorSubject<number>;
  remainingSeconds: BehaviorSubject<number>;
  remainingHours: BehaviorSubject<number>;
  remainingSessHours: number = 0;
  remainingSessMinutes: number = 0;
  remainingSessSeconds: number = 0;
  // showTimerConfrm: boolean = false;
  // showTimerConfrmOpened: any = false;
  modalRef: any;
  loginTimerId: any = '';
  timerId: any = '';
  loginTime: Date = new Date();

  constructor(private apiService: ApiService,
    private alertService: AlertService,
    private router: Router
  ) {
    this.visibility = new BehaviorSubject<boolean>(false);
    this.showSpinner = new BehaviorSubject<boolean>(false);
    this.remainingHours = new BehaviorSubject<number>(0);
    this.remainingMinutes = new BehaviorSubject<number>(0);
    this.remainingSeconds = new BehaviorSubject<number>(0);
  }

  refreshToken() {
    const store = this.getToken();
    this.commonApiCall(
      LOGIN.RefreshToken,
      HttpMethod.POST,
      {
        token: store.accessToken,
        refreshToken: store.refreshToken,
      },
      (res: any, statusFlag: boolean) => {
        if (statusFlag) {
          this.setToken(res);
          // this.showTimerConfrmOpened = false;
          // this.showTimerConfrm = false;
          this.remainingHours.next(0);
          this.remainingMinutes.next(0);
          this.remainingSeconds.next(0);
          // this.appService.showTimerConfrmOpened = false;
          // this.appService.showTimerConfrm = false;
          this.remainingSessHours = 0;
          this.remainingSessMinutes = 0;
          this.remainingSessSeconds = 0;
          this.startTimmer();
        } else {
          this.logOut(false);
        }
      }
    );
  }

  logOut(isLogout = true) {
    if (isLogout) {
      this.commonApiCall(
        LOGIN.logout,
        HttpMethod.GET,
        null,
        (result: any, statusFlag: boolean) => {
          if (statusFlag) {
            // if (this.sessionService.loginTimerId) {
            //   this.sessionService.clearLoginTimeInterval();
            // }
            // this.appService.showTimerConfrmOpened = false;
            // this.appService.showTimerConfrm = false;
            this.remainingHours.next(0);
            this.remainingMinutes.next(0);
            this.remainingSeconds.next(0);
            this.remainingSessHours = 0;
            this.remainingSessMinutes = 0;
            this.remainingSessSeconds = 0;
            // this.showTimerConfrmOpened = false;
            // this.showTimerConfrm = false;
            this.cmnLogout();
            // this.appService.modalRef.close();
          }
        });
    } else {
      this.cmnLogout()
    }
  }

  private cmnLogout() {
    Swal.close();
    if (this.timerId) {
      clearInterval(this.timerId);
    }
    // this.modal.dismiss('Cross click');
    localStorage.clear();
    this.router.navigate([RedirectRoutes.LOGIN]);
    this.hideSpinnerMethod();
  }

  hide() {
    this.visibility.next(false);
  }

  startTimmer() {
    this.stopTimmer();
    const date = this.getToken();
    const expireDate: any = new Date(new Date().getTime() + date.sessionTime * 60000);
    let obj = { startDateTime: this.loginTime, sessionTime: date.sessionTime, expireDate: expireDate };
    localStorage.setItem("loggedInTime", JSON.stringify(obj));

    // const expireDate: any = new Date(new Date().getTime() + date.sessionTime * 60000);
    // this.subscription = interval(1000).subscribe(x => { this.appService.loginTimerRun(expireDate); });

  }

  stopTimmer() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.loginTimerId) {
      this.clearLoginTimeInterval();
    }
    this.remainingSessHours = 0;
    this.remainingSessMinutes = 0;
    this.remainingSessSeconds = 0;
    this.remainingHours.next(0);
    this.remainingMinutes.next(0);
    this.remainingSeconds.next(0);
  }

  clearLoginTimeInterval() {
    clearInterval(this.loginTimerId);
  }

  getToken() {
    return JSON.parse(localStorage.getItem(Appconfig.CURRENTJWTTOKEN) as string);
  }

  setToken(token: string) {
    localStorage.setItem(Appconfig.CURRENTJWTTOKEN, JSON.stringify(token));
  }

  showSpinnerMethod() {
    this.visibility.next(true);
    this.showSpinner.next(true);
    // console.log('Visibility:', true);
  }

  commonApiCall(url: string, methodType: HttpMethod, requestObj: any, callBack: any, endUserMessage?: any) {
    // this.show();
    this.showSpinnerMethod();
    this.apiHandler(methodType, url, requestObj).subscribe({
      next: (res: any) => {
        if (
          !checkNullorUndefined(res) &&
          res.hasOwnProperty('response')
        ) {
          if (res.hasOwnProperty('isSuccess') && res.isSuccess) {
            this.getMessages(res, AlertInfo.SUCCESS, methodType, endUserMessage ?? true);
            callBack(res.response, true);
          } else if (res.hasOwnProperty('isSuccess') && !res.isSuccess) {
            this.getMessages(res, AlertInfo.ERROR, methodType, endUserMessage ?? true);
            this.hideSpinnerMethod();
            callBack(res, false);
          }
        }
      },
      error: (error: any) => {
        this.hideSpinnerMethod();
        callBack(null, false);
        // this.alertService.showMessage(AlertInfo.ERROR, error);
      }
    });
  }

  hideSpinnerMethod() {
    this.visibility.next(false);
    this.showSpinner.next(false);
    // console.log('Visibility:', false);
  }

  private getMessages(res: any, type: AlertInfo, methodType: HttpMethod, endUserMessage: boolean) {
    if (methodType == HttpMethod.GET && type == AlertInfo.SUCCESS) {
      return;
    }
    if (
      !checkNullorUndefined(res.endUserMessage) && res.endUserMessage != '' && endUserMessage
    ) {
      this.alertService.showMessage(type, res.endUserMessage);
    }
  }

  apiHandler(methodType: HttpMethod, url: string, requestObj: any) {
    switch (methodType) {
      case HttpMethod.POST:
        return this.apiService.commonPostHandler(url, requestObj);
      case HttpMethod.PUT:
        return this.apiService.commonPutHandler(url, requestObj);
      case HttpMethod.DELETE:
        return this.apiService.commonDeleteHandler(url);
      case HttpMethod.GET:
        return this.apiService.commonGetHandler(url);
      default:
        return this.apiService.commonGetHandler(url);
    }
  }

}


